import { Component, OnInit,Output,EventEmitter, OnDestroy } from '@angular/core';
import { PatientsService } from '../patients.service';
import { PregnancyService} from '../pregnancy.service';
import {ExamsService} from '../exams.service';
import { Patient } from '../patients/patient';
import { LoginService } from '../login.service';

import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-examsbar',
    templateUrl: './examsbar.component.html',
    styleUrls: ['./examsbar.component.scss'],
    standalone: false
})
export class ExamsbarComponent implements OnInit, OnDestroy {
  @Output() pageChange = new EventEmitter<string>();
  @Output() showPatDetails = new EventEmitter();
  currentPage = "Preparation";
  showPat:boolean=false;
  sub = new Subscription()
  isBookmark =false;
  
  pat:Patient;
  constructor(public patservice: PatientsService, private pregServ: PregnancyService, public es: ExamsService, private router: Router, public ls: LoginService) { }

  ngOnInit() {
    this.pat = this.patservice.getPat();
    if(this.pat.ID == 'default')
      this.currentPage = 'Placenta';
    
    if (this.ls.isGastro && this.es.ExamType !== "Abdomen US" && this.es.ExamType !== 'Hemorrhoids Treatment') {
      this.currentPage = "Preparation";
    } else if (this.es.ExamType === 'Hemorrhoids Treatment') {
      this.currentPage = "Procedure Summary";
    } else {
      this.currentPage = "Abdomen US";
    }
    if(this.es.loadedFromLabResults){
      if(this.es.loadedFromLabResults == 'needsPayer'){
        this.currentPage = 'SummaryGastro';
      }
      else
        this.currentPage = 'Pathologies';
    }
    
    this.sub = this.es.NTAdd$.subscribe(() => {
      if(!this.es.addNT)
        this.setPage('Placenta')
    })
  }

  setPage(page:string){
    this.es.ShowSRs=false;
    this.currentPage=page;
    this.pageChange.emit(page);
  }

  showPatD(){
    this.showPatDetails.emit();
  }

  go(place:string){
    this.router.navigateByUrl(place);
    this.es.exitExam();
  }

  bookmark(){
    console.log(this.es.examID);
    this.isBookmark = !this.isBookmark
  }

  ngOnDestroy(): void {
    if(this.sub){
      this.sub.unsubscribe()
    }
  }

}
